// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ background: "#0f172a" }} className="text-light">

      <div className="container py-5">

        <div className="row g-4">

          {/* MISSION */}
          <div className="col-lg-4 col-md-6">
            <h6 className="fw-bold mb-3 text-white">Our Mission</h6>

            <small className="text-light opacity-75 d-block mb-3">
              To empower educators and learners through AI-driven solutions,
              building an ecosystem that transforms education for the future.
            </small>

            <div className="d-flex gap-3">

              <i className="fab fa-facebook-f"></i>
              <i className="fab fa-twitter"></i>
              <i className="fab fa-instagram"></i>
              <i className="fab fa-linkedin-in"></i>
              <i className="fab fa-youtube"></i>

            </div>
          </div>

          {/* LINKS */}
          <div className="col-lg-2 col-md-3 col-6">
            <h6 className="fw-bold mb-3 text-white">About</h6>

            <ul className="list-unstyled small">
              <li className="mb-2"><Link to="/about" className="footer-link">Our Team</Link></li>
              <li className="mb-2"><Link to="/impact" className="footer-link">Our Impact</Link></li>
              <li><Link to="/partners" className="footer-link">Partners</Link></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 col-6">
            <h6 className="fw-bold mb-3 text-white">Support</h6>

            <ul className="list-unstyled small">
              <li className="mb-2"><Link to="/help" className="footer-link">Help Center</Link></li>
              <li className="mb-2"><Link to="/support" className="footer-link">Community</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 col-6">
            <h6 className="fw-bold mb-3 text-white">Subjects</h6>

            <ul className="list-unstyled small">
              <li className="mb-2"><Link to="/math" className="footer-link">Math</Link></li>
              <li className="mb-2"><Link to="/biology" className="footer-link">Biology</Link></li>
              <li><Link to="/physics" className="footer-link">Physics</Link></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 col-6">
            <h6 className="fw-bold mb-3 text-white">Resources</h6>

            <ul className="list-unstyled small">
              <li className="mb-2"><Link to="/downloads" className="footer-link">Downloads</Link></li>
              <li className="mb-2"><Link to="/blog" className="footer-link">Blog</Link></li>
              <li><Link to="/teachers" className="footer-link">For Teachers</Link></li>
            </ul>
          </div>

        </div>

        {/* CTA */}
        <div className="mt-5 p-4 rounded-4" style={{ background: "#111827" }}>

          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-3">

            <div>
              <h6 className="fw-bold mb-1 text-white">Join our mission</h6>
              <small className="text-light opacity-75">
                Help us shape the future of education.
              </small>
            </div>

            <div className="d-flex gap-2">
              <Link to="/donate" className="btn btn-light btn-sm rounded-3">
                Donate
              </Link>
              <Link to="/volunteer" className="btn btn-outline-light btn-sm rounded-3">
                Volunteer
              </Link>
            </div>

          </div>

        </div>

        {/* BOTTOM */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 pt-3 border-top border-secondary">

          <small className="text-light opacity-75 mb-2 mb-md-0">
            © {currentYear} EduLinker
          </small>

          <div className="d-flex gap-3 small">
            <Link to="/terms" className="footer-link">Terms</Link>
            <Link to="/privacy" className="footer-link">Privacy</Link>
            <Link to="/cookies" className="footer-link">Cookies</Link>
          </div>

        </div>

      </div>
    </footer>
  );
}

export default Footer;